import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Toggle from 'material-ui/Toggle';

import { translate, showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';

import FlatButton from 'material-ui/FlatButton';

//import custom rest client
import { UPDATE } from 'admin-on-rest';
import restClient from '../restClient';

//return <FlatButton label={ this.state.label } onClick={this.handleClick} />;
const styles = {
  block: {
    maxWidth: 250,
  },
  toggle: {
    marginBottom: 16,
  },
  thumbOff: {
    backgroundColor: '#DC4834',
  },
  trackOff: {
    backgroundColor: '#ff9d9d',
  },
  thumbSwitched: {
    backgroundColor: '#298771',
  },
  trackSwitched: {
    backgroundColor: '#76BFAE',
  },
  green: {
	color: '#298771',
  },  
  red: {
	color: '#DC4834',
  }
};

class AdsByDomain extends Component {
   	constructor(props){
	    super(props);
    	this.state = { 
				user_id: props.record.id
		};
  	}
	
    handleClick = () => {
        const { record, showNotification, push } = this.props;
        push('/admin/ad?filter=%7B"cloudhintsdomains_id"%3A'+record.id+'%7D');
    }

    render() {
		return <FlatButton style={styles.forgotPass} label='Advertenties' fullWidth={true} onClick={this.handleClick} />	
    }
}

AdsByDomain.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(AdsByDomain);


// WEBPACK FOOTER //
// ./src/cloudhints_domains/AdsByDomain.js